import useTenant from './useTenant';
import useCollectionsFetch from './useCollectionsFetch';

export default function useCollectionsFetchInTenant(refs, dependencies = [], ...args) {
  const tenant = useTenant();
  const refsWithTenant = refs?.map(_ => _.where('tenantId', '==', tenant.id));

  return useCollectionsFetch(refsWithTenant, [...dependencies, tenant], ...args)
}
